//import MyAlgoButton from "../components/MyAlgoButton"
//import MyAlgoPayFeeButton from "../components/MyAlgoPayFeeButton";

import {PeraWalletConnect} from "@perawallet/connect"
import Container from "react-bootstrap/esm/Container"
import Table from 'react-bootstrap/Table';
import axios from "axios"
import {useState, useEffect} from "react"
import Button from 'react-bootstrap/Button'
import perawalletimg from "../images/perawallet.png"
import algosdk from "algosdk";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";

export default function Members() {
  let [userReloaded, setuserReloaded] = useState(false);
  let [user, setUser] = useState(JSON.parse(window.localStorage.getItem("user")))
  let [pera, setPera] = useState(JSON.parse(window.localStorage.getItem("PeraWallet.Wallet")))

  const [isLoading, setIsLoading] = useState(false);
  const [isWaitingForConfirmation, setIsWaitingForConfirmation] = useState(false);

  const [refInputValue, setRefInputValue] = useState('');

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    window.localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  const handleRefInputChange = (event) => {
    setRefInputValue(event.target.value);
  };

  async function getData(walletofchoice) {

    setIsLoading(true);
    const headers = {Authorization: `Bearer ${user.token}`};
    const data = {username: user.username};

    try {
      const response = await axios.post('/api/users/membdet', data, {headers});

      let updatedUser = {...user, ...response.data}

      if (walletofchoice) {
        updatedUser = {...updatedUser, ...{walletofchoice: walletofchoice}};
      }

      setUser(updatedUser);

      setPera(JSON.parse(window.localStorage.getItem("PeraWallet.Wallet")));

      setuserReloaded(true);

      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const connectToPera = async () => {
    try {
      setIsLoading(true);

      const peraWallet = new PeraWalletConnect();
      const accounts = await peraWallet.connect()

      if (accounts) {
        const data = {username: user.username, addr: accounts[0]}
        //console.log(data)
        //dispatch(userThunks.sendwa(data))
        const headers = {Authorization: `Bearer ${user.token}`}
        await axios.post('/api/users/sendwa', data, {headers})
          .then(response => console.log(response))

        getData("Pera");
      }
    } catch (err) {
      console.error(err)
    }
  }


  const payStarterFee = async () => {

    try {
      const enc = new TextEncoder();
      let note = enc.encode(refInputValue);
      const user = JSON.parse(window.localStorage.getItem("user"))
      const algodClient = new algosdk.Algodv2('', 'https://mainnet-api.algonode.network/', 443);

      const suggestedParams = await algodClient.getTransactionParams().do();
      const planTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
        from: user.walletaddress,
        to: "2RCTDVFTMYFDMGAVPNNGMOB24Z6SOCYD5HCYYCALVSWO34CNOEFEM5WWZ4",
        //assetIndex: 923640017, // IAQ
        //amount: 25000, // 250 IAQ Tokens
        assetIndex: 31566704, // USDC
        note: note,
        amount: 50000000, // 50 USDC
        suggestedParams
      });

      try {
        //alert("When you sign the transaction wait for this dialog to appear again, with the transaction ID number, before you refresh the page!");
        const peraWallet = new PeraWalletConnect()
        peraWallet.reconnectSession()
        const singleTxnGroups = [{txn: planTxn, signers: [user.walletaddress]}];
        const signedTxn = await peraWallet.signTransaction([singleTxnGroups]);
        let txId = planTxn.txID().toString();

        setIsWaitingForConfirmation(true);
        const response = await algodClient.sendRawTransaction(signedTxn).do();
        let confirmedTxn = await algosdk.waitForConfirmation(algodClient, txId, 8);
        setIsWaitingForConfirmation(false);

        //console.log(response.txId)
        if (txId !== "") {
          const data = {username: user.username, txid: txId}
          const headers = {Authorization: `Bearer ${user.token}`}
          await axios.post('/api/users/sendplan', data, {headers})
            .then(response => console.log(response))

          getData();

          alert("Successful transaction! txID : " + txId);
        }
      } catch (error) {
        alert("Transaction failed!\n\nPlease try again and validate that you have enough funds in your wallet to proceed.");
        console.log("Couldn't sign asset transfer txns", error);
      }

    } catch (err) {
      console.error(err)
    }
  }
  const payBondFee = async () => {

    try {
      const enc = new TextEncoder();
      const algodClient = new algosdk.Algodv2('', 'https://mainnet-api.algonode.network/', 443);

      const suggestedParams = await algodClient.getTransactionParams().do();
      const planTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
        from: user.walletaddress,
        to: "FPG7PECKJ3I7XTLRHFIW5EW7WMAELH7NN5AC2PG4KY7WJDDJP5I5RUELAA",
        //assetIndex: 923640017, // IAQ
        //amount: 25000, // 250 IAQ Tokens
        assetIndex: 31566704, // USDC
        // note: note,
        amount: 25000000, // 25 USDC
        suggestedParams
      });

      try {
        //alert("When you sign the transaction wait for this dialog to appear again, with the transaction ID number, before you refresh the page!");
        const peraWallet = new PeraWalletConnect()
        peraWallet.reconnectSession()
        const singleTxnGroups = [{txn: planTxn, signers: [user.walletaddress]}];
        const signedTxn = await peraWallet.signTransaction([singleTxnGroups]);
        let txId = planTxn.txID().toString();

        setIsWaitingForConfirmation(true);
        const response = await algodClient.sendRawTransaction(signedTxn).do();
        let confirmedTxn = await algosdk.waitForConfirmation(algodClient, txId, 8);
        setIsWaitingForConfirmation(false);

        //console.log(response.txId)
        if (txId !== "") {
          const data = {username: user.username, txid: txId}
          const headers = {Authorization: `Bearer ${user.token}`}
          await axios.post('/api/users/sendplan', data, {headers})
            .then(response => console.log(response))

          getData();

          alert("Successful transaction! txID : " + txId);
        }
      } catch (error) {
        alert("Transaction failed!\n\nPlease try again and validate that you have enough funds in your wallet to proceed.");
        console.log("Couldn't sign asset transfer txns", error);
      }

    } catch (err) {
      console.error(err)
    }
  }

  const doOptIn = async () => {
    try {
      const algodClient = new algosdk.Algodv2('', 'https://mainnet-api.algonode.network/', 443);

      const suggestedParams = await algodClient.getTransactionParams().do();
      const optInTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
        from: user.walletaddress,
        to: user.walletaddress,
        assetIndex: 923640017,
        amount: 0,
        suggestedParams
      });

      try {
        //alert("When you sign the transaction wait for this dialog to appear again, with the transaction ID number, before you refresh the page!");
        const peraWallet = new PeraWalletConnect()
        peraWallet.reconnectSession()
        const singleTxnGroups = [{txn: optInTxn, signers: [user.walletaddress]}];
        const signedTxn = await peraWallet.signTransaction([singleTxnGroups]);
        let txId = optInTxn.txID().toString();

        setIsLoading(true);
        const response = await algodClient.sendRawTransaction(signedTxn).do();
        let confirmedTxn = await algosdk.waitForConfirmation(algodClient, txId, 8);
        setIsLoading(false);
        //console.log(response.txId)
        if (txId !== "") {
          getData();

          alert("Successful transaction! txID : " + txId);
        }
      } catch (error) {
        console.log("Couldn't sign asset transfer txns", error);
      }
    } catch (err) {
      console.error(err)
    }
  }

  const notEnoughToken = (amount, token) => {
    alert(`You don't have enough tokens in your wallet to purchase this plan.\n\nYou need ${amount} ${token} to proceed.\n\nPlease reload the page when you have enough tokens in your wallet.`)
  }

  return (
    <Container>

      {isLoading ?
        <div id="overlay">
          <p className="my-3 fs-3 fw-bolder">Loading...</p>
          <Spinner animation="border" variant="success" role="status"></Spinner>
        </div> : <></>
      }

      {isWaitingForConfirmation ?
        <div id="overlay">
          <p className="my-3 fs-3 fw-bolder">Waiting for the confirmation</p>
          <Spinner animation="border" variant="success" role="status"></Spinner>
        </div> : <></>
      }

      <div className="text-center">
        <h1 id="config_header" className="members-header">Account details</h1>
        <div className="bottom-line"></div>
        <h2 id="config_username">{user.username} {user.verified ? <span className={"verified-badge"} title={"Verified"}><i className="bi bi-check-circle"></i></span> : <></>}</h2>
        <br/>
        <br/>
      </div>
      <div className="table-wrapper">
        <Table bordered variant="dark">
          <thead>
          <tr id="table_th">
            <th scope="col">Wallet address</th>
            <th scope="col">Active plan</th>
            <th scope="col">IAQ tokens (Wallet + Cometa)</th>
            <th scope="col">IAQ LP tokens (Wallet + Cometa)</th>
            <th scope="col">USDC</th>
            <th scope="col">Balance</th>
            <th scope="col">Bond Purchased</th>
            <th scope="col">Starter Purchased</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td className="wallet-cell" data-label="Wallet address">{user.walletaddress ? user.walletaddress : "..."}</td>
            <td data-label="Active plan">{user.plan ? user.plan : "..."}</td>
            <td data-label="IAQ tokens - including Cometa">{user.iaq ? user.iaq : 0}</td>
            <td data-label="IAQ LP - including Cometa">{user.iaqlp ? user.iaqlp : 0}</td>
            <td data-label="USDC">{user.usdc ? user.usdc : 0}</td>
            <td data-label="Balance">{user.balance ? user.balance : 0}</td>
            <td data-label="Bond Purchased">{user.bondPurchased ? "Yes" : "No"}</td>
            <td data-label="Starter Purchased">{user.starterPurchased ? "Yes" : "No"}</td>
            <td data-label="Last Stream">{user.lastStream ? user.lastStream.replace(/T/, ' ').replace(/\..+/, '') + " UTC" : "Never"}</td>
          </tr>
          </tbody>
        </Table>
      </div>
      <hr/>

      {userReloaded ?
        <div>
          {!user.walletaddress || !user.walletofchoice || !pera ?
            <div className="text-center">
              <Button id="myAlgoConnectButton" variant="danger" onClick={connectToPera}><img src={perawalletimg} alt="" width="30"/> Connect with Pera wallet</Button>
            </div>
            :
            <div className="text-center">
              {/* Opt-in button */}
              {user.iaqopted !== "yes" ?
                <Button id="myAlgoConnectButton" variant="danger" onClick={doOptIn}><img src={perawalletimg} alt="" width="30"/> IAQ Token Opt-In</Button>
                : <></>}

              {/* Starter button */}
              {!user.starterPurchased ?
                <Form>
                  <Form.Group controlId="formBasicInput">
                    <Form.Label>If you have a referral code type it below (Valid for Starter Plan Only)</Form.Label>
                    <div className="d-flex justify-content-center">
                      <Form.Control type="text" placeholder="Referal code" size="sm !important" style={{width: '200px'}} value={refInputValue} onChange={handleRefInputChange}/>
                    </div>
                  </Form.Group>
                  <Button id="myAlgoConnectButton" variant="danger" onClick={user.usdc < 50 ? () => notEnoughToken(50, 'USDC') : () => payStarterFee()}><img src={perawalletimg} alt="add item" width="30"/> Purchase Starter Plan</Button>
                </Form>
                : <></>}

              {/* Bond button */}
              {!user.bondPurchased ?
                <Button id="myAlgoConnectButton" variant="danger" onClick={user.usdc < 25 ? () => notEnoughToken(25, 'USDC') : () => payBondFee()}><img src={perawalletimg} alt="add item" width="30"/> Purchase Bond Plan</Button>
                : <></>}
            </div>
          }
        </div>
        : <></>}


      {/* <h6>If your device isn't streaming and <b>you don't see a USDC balance changed on the page to reflect the actual amount in your wallet, and you wish to obtain a Starter Plan</b></h6>
            <h5 id="member_color">please logout and log back in, then connect the wallet again, your balance should be updated then</h5>
            <br></br> */}
      {/* <p>If the "Purchase Starter Plan" isn't working for you for some reason, you can send manual transaction <b>(50 USDC)</b> to <b>elementdata.algo</b> (2RCTDVFTMYFDMGAVPNNGMOB24Z6SOCYD5HCYYCALVSWO34CNOEFEM5WWZ4)
                 <b>  with your username</b> in the transaction note</p>    */}
      <div className="">
        {/* <Button variant="success" onClick={()=>nav("/changepw")}>Change Password</Button>  */}
        <hr/>
        {/* <p>If the "Purchase Starter Plan" isn't working for you for some reason, you can send manual transaction <b>(50 USDC)</b> to <b>elementdata.algo</b> (2RCTDVFTMYFDMGAVPNNGMOB24Z6SOCYD5HCYYCALVSWO34CNOEFEM5WWZ4)
                 <b>  with your username</b> in the transaction note</p>       */}
        <p>If you are a new user, after adding a wallet address please <b>optin</b> to IAQ token by clicking on the OptIn button, or you can add the asset manually, ID is 923640017</p>
        {/* <p>If you upgrade from Starter to Premium plan and later you decide to leave Premium plan, you will be downgraded to Default plan</p> */}
        {/* <p>Basic and Premium plans will be automatically activated if requirements are met (wallet balances are updated every hour)</p>                 */}
        <p>Premium plan will be automatically activated if requirements are met (<b>wallet balances are updated with each stream or when a page is refreshed</b>)</p>
        <p>If you have more devices and wish to be Premium as well on those by using the same wallet address, you would then need 5 LPs for each additional device</p>
        <p>Example: same wallet address, for 2 devices you would need 10 LP tokens in the wallet, otherwise if you want different addresses then 5 LPs in each wallet</p>
        {/* <p>If you have more devices using the same wallet for Basic and Premium plans, only 1 device will be Basic/Premium, if you wish to use other devices with those plans then you would have to use different wallet and meet the requirements for those plans again</p>                 */}
        {/* <p>If you have more devices using the same wallet for Premium plan, only 1 device will be Premium, if you wish to use other devices with that plan then you would have to use different wallet and meet the requirements for that plan again</p>                 */}
        {/* <p>For now you can use more devices with the same wallet and same location with the Default plan, but that will be changed soon</p>                 */}
        <p>When you logout, you will also disconnect from the wallet, if you already added wallet address then there's no need to connect again,
          <b>unless you want to obtain one of the plans.</b></p>
        <hr/>
      </div>
      <br/>
      <br/>
    </Container>
  )
}
